import styled from "styled-components";

export const MyReservationWrapper = styled.div<{ isApp: null | number }>`
  position: relative;
  height: 100%;
  background: white;
  overflow: auto;
  top: ${(p) => (p.isApp ? `${p.isApp}px` : "0")};
  padding-bottom: ${(p) => (p.isApp ? `${p.isApp}px` : "0")};
`;

export const MyReservationHeader = styled.div<{ isApp: null | number }>`
  z-index: 101;
  transition: all 0.1s ease-in-out;
  top: 0;
  position: fixed;
  max-width: 500px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 48px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0 20px;
  gap: 8px;
  background-color: white;
  padding-top: ${(p) => (p.isApp ? `${p.isApp + 12}px` : "0")};
  padding-bottom: ${(p) => (p.isApp ? `${24}px` : "0")};
  .close {
    cursor: pointer;
    width: 24px;
    height: 24px;
    position: absolute;

    svg path {
      stroke: var(--Black-400, #444);
    }
  }

  .title {
    text-align: center;
    width: 100%;

    font-weight: 600;
    font-size: 16px;
    line-height: 100%;
  }
`;

export const MyReservationContentWrapper = styled.div`
  margin-top: 48px;
  padding: 20px 16px;

  > .filter-wrapper {
    display: flex;
    gap: 12px;
  }
`;

export const CancelWrapper = styled.div`
  position: absolute;
  width: 308px;
  height: 152px;
  border-radius: 12px;
  background: #ffffff;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 10000;

  > .title {
    font-weight: 600;
    font-size: 14px;
    text-align: center;
  }

  > .button-wrapper {
    display: flex;

    > .button {
      flex: 1;
      height: 48px;
      border-radius: 8px;
      color: var(--Purple-300, #6436e7);
      text-align: center;
      line-height: 48px;

      font-weight: 600;
      font-size: 15px;

      &.red {
        background: #d91818;
        color: #fff;
      }
    }
  }
`;
